export const blikInvoiceLayoutSettings = {
  hide_header: true,
  hide_footer: true,
  hide_progress_bar: true,
  hide_method_filter: true,
};
